import { render } from "./contact-details-modal.vue?vue&type=template&id=47eb9fa0"
import script from "./contact-details-modal.vue?vue&type=script&lang=js"
export * from "./contact-details-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__